<template>
    <main-layout>
        <div  class="top80 is-hidden-mobile">&nbsp;</div>
       <div class="container"><img class="rounded" src="@/assets/img/slinkOnePage.png" /></div>
       <br> <br>
       <div class="has-text-centered"><button class="button is-yell is-large" @click="$router.push('/get')"><b>GET STARTED</b></button></div>
       <br> <br>
    </main-layout>
</template>

<script>
import MainLayout from '../layouts/Main.vue'

export default {
  components: {
    MainLayout
  }
}

</script>


// WEBPACK FOOTER //
// src/pages/OnePager.vue